import React, { Component } from 'react';
import {Input, Button} from 'reactstrap';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import CKEditorUI from '../../../../components/CKEditor/CKEditorUI';

class ItemDescription extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      description: {
        value: "",
        error: false
      },
    }
  }
 

  changeItemDesc = (event) => {
    const descriptionContext = event.editor.getData();
    let{description}=this.state
    if(description.value!=descriptionContext){
      this.setState({ description: { value: descriptionContext }})
      // this.checkUpdateField('description')
    }
  }


  render() { 
      const { description } = this.state;
    return ( 
      <CKEditorUI 
        onChange= {this.changeItemDesc}
        value= {description.value}
      />
    );
  }
}
 
export default ItemDescription;